import { httpAuthorized } from "@/main";
import { handleRequest } from "..";

/** 管理端账号（开发公司内部员工账号，manager 表） */
export interface ManagerAccount {
  id: string;
  name: string;
  username: string;
  email: string;
  /** "1"=超级管理员 "2"=普通用户 */
  level?: string;
  isDeleted: number;
  createtime?: string;
}

export const getManagerListApi = async (): Promise<ManagerAccount[] | null> => {
  return handleRequest<ManagerAccount[]>(
    httpAuthorized.get("/managerAccount/getManagerList"),
    (data) => data.data.managerList
  );
};

export const createManagerApi = async (payload: {
  name: string;
  username: string;
  password: string;
  email: string;
}): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/managerAccount/createManager", payload),
    (data) => data.data.result
  );
};

export const toggleManagerApi = async (id: string): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/managerAccount/toggleManager", { id }),
    (data) => data.data.result
  );
};

export const deleteManagerApi = async (id: string): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/managerAccount/deleteManager", { id }),
    (data) => data.data.result
  );
};
